// src/components/kanban/SortableTaskCard.tsx
/**
 * Wrapper draggable/sortable per TaskCardView: applica `useSortable` e passa
 * attributes/listeners come `dragHandleProps` (drag sull'intera superficie della card).
 * Usato solo per i task attivi di una colonna: i completati usano TaskCardView "nudo",
 * non trascinabile.
 */
import { memo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import TaskCardView, { type TaskCardViewProps } from './TaskCardView';
import { taskDndId } from './board-utils';

type SortableTaskCardProps = Omit<TaskCardViewProps, 'dragHandleProps' | 'overlay' | 'completed'>;

const SortableTaskCard = memo(function SortableTaskCard({ task, ...rest }: SortableTaskCardProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: taskDndId(task.id),
    data: { type: 'task', taskId: task.id, columnId: task.kanbanColumnId },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <TaskCardView task={task} dragHandleProps={{ attributes, listeners }} {...rest} />
    </div>
  );
});

export default SortableTaskCard;
